import { SVGProps } from 'react';

const TickRound = (props: SVGProps<SVGSVGElement>) => {
  const { className } = props;
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className={className}
      data-palette="TickRound">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0L18 0 18 18 0 18z"
                transform="translate(-245 -348) translate(220 328) translate(25 20)"
              />
              <path
                fill="currentColor"
                fillRule="nonzero"
                d="M9 16.5c-4.142 0-7.5-3.358-7.5-7.5 0-4.142 3.358-7.5 7.5-7.5 4.142 0 7.5 3.358 7.5 7.5 0 4.142-3.358 7.5-7.5 7.5zM9 15c3.314 0 6-2.686 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6zm-.748-3L5.07 8.818l1.06-1.06 2.122 2.121 4.242-4.243 1.062 1.06L8.252 12z"
                transform="translate(-245 -348) translate(220 328) translate(25 20)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default TickRound;
